// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeRange_root__1IE1y","bookingInfo":"TimeRange_bookingInfo__Uw_BW","dateSection":"TimeRange_dateSection__24PgQ"};